import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { RouterLink } from '@angular/router';

import { regularFontSizeAnimation } from '@app/shared/animations/font-size.animations';
import { SideBarItemConfig } from '@core/layout/sidebar/sidebar-item/sidebar-item.model';

@Component({
  selector: 'app-sidebar-item',
  templateUrl: './sidebar-item.component.html',
  styleUrl: './sidebar-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [regularFontSizeAnimation],
  imports: [RouterLink, NgClass],
})
export class SidebarItemComponent {
  public readonly link = input<string | null>(null);
  public readonly icon = input('');
  public readonly itemText = input('');
  public readonly isSidebarOpen = input(false);
  public readonly activeItem = input('');
  public readonly nestedItems = input<SideBarItemConfig[] | undefined>([]);

  public readonly nestedItemEvent = output<string>();

  public get hasNestedItems(): boolean {
    return !!this.nestedItems()?.length;
  }

  public isParentActive(): boolean {
    const nestedItems = this.nestedItems();

    if (!nestedItems) {
      return this.activeItem() === this.itemText();
    }
    const activeChildItem = this.activeItem().split('.')[1];
    for (const item of nestedItems) {
      if (activeChildItem === item.itemText) {
        return true;
      }
    }
    return false;
  }

  public isChildActive(itemText: string): boolean {
    const nestedItems = this.nestedItems();

    if (!nestedItems) {
      return false;
    }
    const activeChildItem = this.activeItem().split('.')[1];
    return activeChildItem === itemText;
  }

  public onNestedItemClick(itemText: string): void {
    this.nestedItemEvent.emit(`${this.itemText()}.${itemText}`);
  }
}
